"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.priceMondialRelayEUByWeights = exports.priceColissimoEUByWeights = exports.mondialRelayInsurancePrices = exports.colissimoInsurancePrices = void 0;
var priceMondialRelayEUByWeights = exports.priceMondialRelayEUByWeights = [{
  minWeight: 0.015,
  maxWeight: 0.250,
  BE: 4.43,
  LU: 4.43,
  NL: 5.27,
  ES: 6.47,
  PT: 6.47
}, {
  minWeight: 0.250,
  maxWeight: 0.500,
  BE: 5,
  LU: 5,
  NL: 6.03,
  ES: 7.39,
  PT: 7.39
}, {
  minWeight: 0.500,
  maxWeight: 1,
  BE: 5.94,
  LU: 5.94,
  NL: 6.66,
  ES: 7.92,
  PT: 7.92
}, {
  minWeight: 1,
  maxWeight: 2,
  BE: 6.89,
  LU: 6.89,
  NL: 7.14,
  ES: 8.20,
  PT: 8.20
}, {
  minWeight: 2,
  maxWeight: 3,
  BE: 8.28,
  LU: 8.28,
  NL: 9.16,
  ES: 10.49,
  PT: 10.49
}, {
  minWeight: 3,
  maxWeight: 4,
  BE: 12.41,
  LU: 12.41,
  NL: 12.41,
  ES: 11.89,
  PT: 11.89
}, {
  minWeight: 4,
  maxWeight: 5,
  BE: 12.41,
  LU: 12.41,
  NL: 12.41,
  ES: 11.89,
  PT: 11.89
}, {
  minWeight: 5,
  maxWeight: 6,
  BE: 14.19,
  LU: 14.19,
  NL: 14.19,
  ES: 13.49,
  PT: 13.49
}, {
  minWeight: 6,
  maxWeight: 7,
  BE: 14.19,
  LU: 14.19,
  NL: 14.19,
  ES: 13.49,
  PT: 13.49
}, {
  minWeight: 7,
  maxWeight: 30,
  BE: 14.30,
  LU: 14.30,
  NL: 14.30,
  ES: 13.60,
  PT: 13.60
}];
var priceColissimoEUByWeights = exports.priceColissimoEUByWeights = [{
  minWeight: 0,
  maxWeight: 1,
  BE: 10.21,
  CH: 14.12,
  DE: 11.03,
  LU: 11.03,
  NL: 11.03,
  UK: 12.67,
  IT: 12.48,
  ES: 12.42,
  AT: 12.67,
  PT: 12.67,
  IE: 12.67,
  OTHER: 14.11,
  BG: 16.54,
  CY: 16.54,
  HR: 16.54,
  FI: 16.54,
  GR: 16.54,
  IS: 16.54,
  MT: 16.54,
  NO: 16.54,
  RO: 16.54
}, {
  minWeight: 1,
  maxWeight: 2,
  BE: 13.52,
  CH: 15.85,
  DE: 14.41,
  LU: 14.41,
  NL: 14.41,
  UK: 16.12,
  IT: 17.75,
  ES: 17.66,
  AT: 18.01,
  PT: 18.01,
  IE: 18.01,
  OTHER: 19.62,
  BG: 22.27,
  CY: 22.27,
  HR: 22.27,
  FI: 22.27,
  GR: 22.27,
  IS: 22.27,
  MT: 22.27,
  NO: 22.27,
  RO: 22.27
}, {
  minWeight: 2,
  maxWeight: 3,
  BE: 14.56,
  CH: 17.32,
  DE: 15.16,
  LU: 15.46,
  NL: 15.46,
  UK: 18.02,
  IT: 18.91,
  ES: 18.82,
  AT: 19.20,
  PT: 19.20,
  IE: 19.20,
  OTHER: 21.38,
  BG: 24.42,
  CY: 24.42,
  HR: 24.42,
  FI: 24.42,
  GR: 24.42,
  IS: 24.42,
  MT: 24.42,
  NO: 24.42,
  RO: 24.42
}, {
  minWeight: 3,
  maxWeight: 4,
  BE: 15.58,
  CH: 19.12,
  DE: 16.18,
  LU: 16.51,
  NL: 16.51,
  UK: 19.20,
  IT: 19.94,
  ES: 19.85,
  AT: 20.24,
  PT: 20.24,
  IE: 20.24,
  OTHER: 23.54,
  BG: 27.31,
  CY: 27.31,
  HR: 27.31,
  FI: 27.31,
  GR: 27.31,
  IS: 27.31,
  MT: 27.31,
  NO: 27.31,
  RO: 27.31
}, {
  minWeight: 4,
  maxWeight: 5,
  BE: 16.52,
  CH: 20.95,
  DE: 17.12,
  LU: 17.47,
  NL: 17.47,
  UK: 20.24,
  IT: 21.02,
  ES: 20.93,
  AT: 21.35,
  PT: 21.35,
  IE: 21.35,
  OTHER: 25.73,
  BG: 32.90,
  CY: 32.90,
  HR: 32.90,
  FI: 32.90,
  GR: 32.90,
  IS: 32.90,
  MT: 32.90,
  NO: 32.90,
  RO: 32.90
}, {
  minWeight: 5,
  maxWeight: 6,
  BE: 17.47,
  CH: 27.74,
  DE: 18.07,
  LU: 18.44,
  NL: 18.44,
  UK: 21.35,
  IT: 22.06,
  ES: 21.94,
  AT: 22.38,
  PT: 22.38,
  IE: 22.38,
  OTHER: 33.89,
  BG: 37.36,
  CY: 37.36,
  HR: 37.36,
  FI: 37.36,
  GR: 37.36,
  IS: 37.36,
  MT: 37.36,
  NO: 37.36,
  RO: 37.36
}, {
  minWeight: 6,
  maxWeight: 7,
  BE: 18.42,
  CH: 29.35,
  DE: 19.02,
  LU: 19.40,
  NL: 19.40,
  UK: 22.38,
  IT: 23.22,
  ES: 23.11,
  AT: 23.57,
  PT: 23.57,
  IE: 23.57,
  OTHER: 35.82,
  BG: 42.56,
  CY: 42.56,
  HR: 42.56,
  FI: 42.56,
  GR: 42.56,
  IS: 42.56,
  MT: 42.56,
  NO: 42.56,
  RO: 42.56
}, {
  minWeight: 7,
  maxWeight: 8,
  BE: 19.02,
  CH: 35.22,
  DE: 19.40,
  LU: 19.40,
  NL: 19.40,
  UK: 22.38,
  IT: 23.22,
  ES: 23.11,
  AT: 23.57,
  PT: 23.57,
  IE: 23.57,
  OTHER: 37.62,
  BG: 42.56,
  CY: 42.56,
  HR: 42.56,
  FI: 42.56,
  GR: 42.56,
  IS: 42.56,
  MT: 42.56,
  NO: 42.56,
  RO: 42.56
}, {
  minWeight: 8,
  maxWeight: 9,
  BE: 19.02,
  CH: 35.22,
  DE: 19.40,
  LU: 19.40,
  NL: 19.40,
  UK: 22.38,
  IT: 23.22,
  ES: 23.11,
  AT: 23.57,
  PT: 23.57,
  IE: 23.57,
  OTHER: 37.62,
  BG: 42.56,
  CY: 42.56,
  HR: 42.56,
  FI: 42.56,
  GR: 42.56,
  IS: 42.56,
  MT: 42.56,
  NO: 42.56,
  RO: 42.56
}, {
  minWeight: 9,
  maxWeight: 10,
  BE: 19.02,
  CH: 35.22,
  DE: 19.40,
  LU: 19.40,
  NL: 19.40,
  UK: 22.38,
  IT: 23.22,
  ES: 23.11,
  AT: 23.57,
  PT: 23.57,
  IE: 23.57,
  OTHER: 37.62,
  BG: 42.56,
  CY: 42.56,
  HR: 42.56,
  FI: 42.56,
  GR: 42.56,
  IS: 42.56,
  MT: 42.56,
  NO: 42.56,
  RO: 42.56
}, {
  minWeight: 10,
  maxWeight: 30,
  BE: 19.02,
  CH: 35.22,
  DE: 19.40,
  LU: 19.40,
  NL: 19.40,
  UK: 22.38,
  IT: 23.22,
  ES: 23.11,
  AT: 23.57,
  PT: 23.57,
  IE: 23.57,
  OTHER: 37.62,
  BG: 42.56,
  CY: 42.56,
  HR: 42.56,
  FI: 42.56,
  GR: 42.56,
  IS: 42.56,
  MT: 42.56,
  NO: 42.56,
  RO: 42.56
}];

// only for international orders
var mondialRelayInsurancePrices = exports.mondialRelayInsurancePrices = [{
  value: 250,
  amount: 5
}, {
  value: 500,
  amount: 8
}];
var colissimoInsurancePrices = exports.colissimoInsurancePrices = [{
  value: 150,
  amount: 1.2
}, {
  value: 300,
  amount: 2.4
}, {
  value: 500,
  amount: 3.6
}, {
  value: 1000,
  amount: 7.2
}, {
  value: 2000,
  amount: 14.4
}, {
  value: 5000,
  amount: 36
}];